// app/shared/utils/accentColors.ts
// Centralized accent color utilities for use across features
// This ensures consistent colors across all components

export type AccentColor = 'teal' | 'purple' | 'yellow' | 'green' | 'orange';

// Background classes for colored sections (quote boxes, hero, etc.)
export const accentBgClasses: Record<AccentColor, string> = {
  teal: 'bg-teal-dark',
  purple: 'bg-purple-dark',
  yellow: 'bg-yellow-dark',
  green: 'bg-green-dark',
  orange: 'bg-orange-dark',
};

// Lighter background classes (for cards, highlights)
export const accentLightBgClasses: Record<AccentColor, string> = {
  teal: 'bg-teal/20',
  purple: 'bg-purple/20',
  yellow: 'bg-yellow/20',
  green: 'bg-green/20',
  orange: 'bg-orange/20',
};

// Border classes for left borders, dividers
export const accentBorderClasses: Record<AccentColor, string> = {
  teal: 'border-l-teal-dark',
  purple: 'border-l-purple-dark',
  yellow: 'border-l-yellow-dark',
  green: 'border-l-green-dark',
  orange: 'border-l-orange-dark',
};

// Border-top classes for speech bubble pointers
export const accentBorderTopClasses: Record<AccentColor, string> = {
  teal: 'border-t-teal-dark',
  purple: 'border-t-purple-dark',
  yellow: 'border-t-yellow-dark',
  green: 'border-t-green-dark',
  orange: 'border-t-orange-dark',
};

// Text classes for accent-colored text
export const accentTextClasses: Record<AccentColor, string> = {
  teal: 'text-teal',
  purple: 'text-purple',
  yellow: 'text-yellow',
  green: 'text-green',
  orange: 'text-orange',
};

// Hover background classes for buttons/interactive elements
export const accentHoverBgClasses: Record<AccentColor, string> = {
  teal: 'group-hover:bg-teal-dark',
  purple: 'group-hover:bg-purple-dark',
  yellow: 'group-hover:bg-yellow-dark',
  green: 'group-hover:bg-green-dark',
  orange: 'group-hover:bg-orange-dark',
};

